import React from 'react';
import { createSvgIcon } from './createSvgIcon';
export const CheckIcon = createSvgIcon({
    displayName: 'Check',
    path: (React.createElement("path", { d: "M19.612.377a1.23 1.23 0 0 0-1.854.008l-12.056 12.4L2.63 9.313a1.5 1.5 0 0 0-1.922-.1c-.735.543-.93 1.636-.432 2.44l4.407 7.135c.152.247.352.477.584.662 1.086.867 2.608.604 3.4-.583l.1-.15L19.748 2.24c.377-.564.332-1.356-.136-1.863", "fill-rule": "evenodd" })),
    viewBox: '0 0 20 20',
});
